import BasketPage from './Basket.vue'


export default {
  routers() {
    return [
      {
        path: '/cart',
        name: 'cart',
        component: BasketPage
      },
    ];
  }
}





// WEBPACK FOOTER //
// ./src/components/basket/src/Router.js